import { render, staticRenderFns } from "./ParcelamentoPgfnEmissao.vue?vue&type=template&id=161abce8&"
import script from "./ParcelamentoPgfnEmissao.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoPgfnEmissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports